// reducers.js
import {
    FETCH_BANNER, FETCH_COLOR_LIST, FETCH_DISLIKE,
    FETCH_DRAWER_MENU,
    FETCH_LATEST_VERSION, FETCH_LICENCE, FETCH_LIKE,
    FETCH_PRODUCT_LIST, FETCH_SPACE_LIST, FETCH_TOTAL_COUNT_LIST,
    SET_BANNER, SET_COLOR_LIST, SET_DISLIKE,
    SET_DRAWER_MENU, SET_LICENCE, SET_LIKE, SET_PRODUCT_LIST, SET_SPACE_LIST, SET_TOTAL_COUNT_LIST
} from '../actions';
import {SET_LATEST_VERSION} from "../actions";
// import {SET_LATEST_VERSION} from "./actionTypes";

const initialState = {
    dislikeFormId: null,
    isLoading: false,
    error: null,
};

const dislikeReducer = (state = initialState, action) => {


    switch (action.type) {

        // case SET_LOADING:
        //     return {
        //         ...state,
        //         isLoading: action.payload,
        //     };
        //
        // case SET_ERROR:
        //     return {
        //         ...state,
        //         error: action.payload,
        //     };

        case FETCH_DISLIKE:
            return {
                ...state,
            };

        case SET_DISLIKE:
            return {
                ...state,
                dislikeFormId: action.payload,
                isLoading: false,
            };

        default:
            return state;
    }
};

export default dislikeReducer;
